import React from "react";

/*
props = {
  options: [{ value: "value1", label: "Label 1" }, ...],
  currentValue: <string>,
  onOptionSelect: <function>
}
*/

const DropdownFilterMenu = ({ options, currentValue, onOptionSelect }) => (
  <div className="mt-1 shadow bg-white py-1 cui-dropdown-filter-menu">
    {options?.map((option) => (
      <div 
        className={`cursor-pointer font-13 py-2 px-3 cui-dropdown-filter-menu-option ${
          option.value === currentValue ? 'cui-dropdown-filter-menu-option--selected' : ''
        }`}
        key={option.value}
        onClick={() => onOptionSelect(option.value)}
      >
        {option.label}
      </div>
    ))}
  </div>
);

export default DropdownFilterMenu;